import { css } from '@emotion/react'

import { Fonts } from '@thebeansgroup/sb_ui/style_helpers'

import { AUTOFILL_ANIMATION_NAME } from './constants'

export const inputStyles = (theme) => css`
  height: 46px;
  padding: 0 12px;
  margin: 0;
  font-size: 16px;
  font-family: ${Fonts('gibson')};
  line-height: 24px;
  color: ${theme.grey500};
  border-radius: 5px;
  border: 1px solid ${theme.grey100};
  background: ${theme.grey50};

  &:focus {
    background: ${theme.grey50};
    border: 1px solid ${theme.primaryColour};
  }
`
export const inputPasswordStyles = css`
  padding: 0 44px 0 12px;
`
export const showPasswordStyles = (theme) => css`
  position: absolute;
  height: 46px;
  right: 0;
  top: 24px;
  cursor: pointer;
  background: none;
  border: none;
  color: ${theme.primaryColour};
  padding: 0 12px 0 8px;
`

export const showPasswordIconStyles = css`
  vertical-align: middle;
`
export const containerStyles = css`
  position: relative;
  padding: 24px 0 24px 0;

  input::-ms-clear,
  input::-ms-reveal {
    display: none;
  }
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @-moz-keyframes ${AUTOFILL_ANIMATION_NAME} {
  }
  @-webkit-keyframes ${AUTOFILL_ANIMATION_NAME} {
  }
  @keyframes ${AUTOFILL_ANIMATION_NAME} {
  }
  input:-webkit-autofill {
    animation-name: ${AUTOFILL_ANIMATION_NAME};
  }
`
